var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 54,
    viewBox: "0 0 85 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 54,
    rx: 5,
    fill: "#5077D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.4191 40.7051C77.4191 43.3082 75.2994 45.4279 72.6963 45.4279H47V26.7228C47 24.1197 49.1197 22 51.7228 22H77.4191V40.7051Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.052 35.908H71.0043C71.0601 35.908 71.1902 35.8894 71.2461 35.8894C71.618 35.815 71.9341 35.4803 71.9341 35.0155C71.9341 34.5693 71.618 34.2346 71.2461 34.1416C71.1902 34.123 71.0788 34.123 71.0044 34.123H69.0521V35.908H69.052Z",
    fill: "url(#paint0_linear_3246_213)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7813 23.5804C68.922 23.5804 67.3972 25.0866 67.3972 26.9645V30.4787H72.1758C72.2874 30.4787 72.4175 30.4787 72.5105 30.4973C73.5889 30.5531 74.3885 31.1109 74.3885 32.0776C74.3885 32.84 73.8492 33.4908 72.8452 33.6211V33.6581C73.9422 33.7325 74.7789 34.3461 74.7789 35.2943C74.7789 36.3171 73.8492 36.9864 72.622 36.9864H67.3787V43.8661H72.3431C74.2025 43.8661 75.7273 42.36 75.7273 40.482V23.5804H70.7813Z",
    fill: "url(#paint1_linear_3246_213)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6923 32.301C71.6923 31.8546 71.3762 31.5571 71.0043 31.5013C70.9672 31.5013 70.8742 31.4827 70.8184 31.4827H69.052V33.1189H70.8184C70.8743 33.1189 70.9858 33.1189 71.0044 33.1004C71.3763 33.0446 71.6924 32.7471 71.6924 32.3008L71.6923 32.301Z",
    fill: "url(#paint2_linear_3246_213)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.076 23.5804C50.2166 23.5804 48.6919 25.0866 48.6919 26.9645V35.3131C49.6402 35.7778 50.6256 36.0754 51.6112 36.0754C52.7825 36.0754 53.4147 35.3688 53.4147 34.402V30.4601H56.3153V34.3833C56.3153 35.9079 55.3671 37.1538 52.1504 37.1538C50.1981 37.1538 48.6733 36.7261 48.6733 36.7261V43.8474H53.6378C55.4972 43.8474 57.0219 42.3413 57.0219 40.4633V23.5806H52.0759L52.076 23.5804Z",
    fill: "url(#paint3_linear_3246_213)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4286 23.5804C59.5692 23.5804 58.0444 25.0866 58.0444 26.9645V31.3898C58.8999 30.6646 60.3873 30.1997 62.7859 30.3113C64.0688 30.3672 65.4447 30.7204 65.4447 30.7204V32.1521C64.7567 31.7989 63.9387 31.4827 62.8788 31.4083C61.0566 31.2782 59.9596 32.1707 59.9596 33.7325C59.9596 35.313 61.0566 36.2055 62.8788 36.0567C63.9387 35.9823 64.7568 35.6477 65.4447 35.313V36.7447C65.4447 36.7447 64.0874 37.098 62.7859 37.1538C60.3873 37.2653 58.8999 36.8004 58.0446 36.0754V43.8846H63.009C64.8684 43.8846 66.393 42.3785 66.393 40.5005V23.5806H61.4286V23.5804Z",
    fill: "url(#paint4_linear_3246_213)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3246_213",
    x1: -96.7459,
    y1: 123.593,
    x2: 738.823,
    y2: 123.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3246_213",
    x1: 68.9065,
    y1: 1037.05,
    x2: 904.518,
    y2: 1037.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3246_213",
    x1: -96.7702,
    y1: 113.061,
    x2: 738.844,
    y2: 113.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3246_213",
    x1: 50.1427,
    y1: 1037.05,
    x2: 898.628,
    y2: 1037.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3246_213",
    x1: 53.2356,
    y1: 1037.05,
    x2: 877.318,
    y2: 1037.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.3fb945aafcd657105c7a986da5fa7528.svg";
export { ForwardRef as ReactComponent };